// extracted by mini-css-extract-plugin
module.exports = {"s-image":"image_s-image__knUx_","s-image_guide":"image_s-image_guide__xXqbG"};